import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'reducers/rootReducer'
import { useCustomTranslation } from 'hooks/useCustomTranslation'
import OurTeamListing from './OurTeamListing/OurTeamListing'
import InnerTitleSection from 'components/InnerTitleSection/InnerTitleSection'
import Loader from 'components/Loader/Loader'

const OurTeam: React.FC = () => {
  const { t, i18n } = useCustomTranslation()
  const currentLanguage = i18n.language
  const isAr = currentLanguage === 'ar'

  const isLoading = useSelector((state: RootState) => state.team.isLoading)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return isLoading ? (
    <Loader />
  ) : (
    <main>
      <InnerTitleSection
        title={t('navOurTeam')}
        breadcrumbs={[
          {
            title: t('navHome'),
            link: `/${currentLanguage}`,
          },
          {
            title: t('navOurTeam'),
          },
        ]}
      />
      <OurTeamListing isAr={isAr} t={t} />
    </main>
  )
}

export default OurTeam
